import {Badge, Button, Card, Col, Form, Row, Spinner} from "react-bootstrap";
import React, {useContext, useEffect, useState} from "react";
import SshCommandsTable from "../../Components/SshCommandsTable/SshCommandsTable";
import moment from "moment/moment";
import {store} from "../../Store/store";
import {TbCopy} from "react-icons/tb";
import {CONNECTED, DISCONNECTED} from "./Types";
import ErrorModal from "./ErrorModal";
import CustomIcon from "../../Components/CustomIcon/CustomIcon";
import keyFileIcon from "../../Images/key-file-icon.svg"
import sshTunnelIcon from "../../Images/ssh-tunnel-icon.svg"

export default function SshPage(props) {
    const [commandsData, setCommandsData] = useState([]);
    const [isSshTunnelActive, setIsSshTunnelActive] = useState(true);
    const [tunnelId, setTunnelId] = useState(null);
    const [isTunnelRequestInProgress, setIsTunnelRequestInProgress] = useState(false);
    const [isFirstRequest, setIsFirstRequest] = useState(true);
    const [isCommandsEmpty, setIsCommandsEmpty] = useState(false);
    const [tunnelDescription, setTunnelDescription] = useState('');
    const [tunnelCreatedAt, setTunnelCreatedAt] = useState('');
    const [intervalId, setIntervalId] = useState(null);
    const [pathValue, setPathValue] = useState('');
    const [userConnectionState, setUserConnectionState] = useState('');
    const [controlUnitConnectionState, setControlUnitConnectionState] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [showErrorModal, setShowErrorModal] = useState(false);
    const POLLING_TIME_INTERVAL = 5000;
    const utcOffset = moment().utcOffset();
    const stateObj = useContext(store);

    const chooseFile = async () => {
        let fileHandle;
        [fileHandle] = await window.showOpenFilePicker();
        const file = await fileHandle.getFile();
        const name = await file.name;
        setPathValue(`<Enter the file path here>\\${name}`);
    }

    const renderConnectionBadge = (str) => {
        let connectionState;
        let color;
        switch (str) {
            case DISCONNECTED:
                connectionState = 'Disconnected';
                color = 'danger'
                break;
            case CONNECTED:
                connectionState = 'Connected';
                color = 'success'
                break;
        }
        return <h6><Badge variant={color}>{connectionState}</Badge></h6>
    }

    const downloadSshKey = async () => {
        const options = {
            suggestedName: `${props.controlUnitId}-ssh`, types: [{
                accept: {
                    "text/plain": [".key"],
                },
            },],
        };
        try {
            const response = await props.controlUnitService.downloadSshKey(props.controlUnitId);
            if (!response) {
                console.error(`Data from download ssh key is empty`);
                return;
            }
            const handle = await window.showSaveFilePicker(options);
            const writable = await handle.createWritable();
            await writable.write(response.data);
            await writable.close();
            const name = await handle.name;
            setPathValue(`<Enter the file path here>\\${name}`);
            return handle;
        } catch (error) {
            if (error.toString() === 'AbortError: The user aborted a request.') {
                return;
            }
            if (error.toString() === "Error: Request failed with status code 404") {
                setErrorMessage('The SSH key file does not exist.');
                setShowErrorModal(true);
                return;
            }
            setErrorMessage(error.toString());
            setShowErrorModal(true);
        }
    }

    const getSshTunnelStatus = (tunnelId) => {
        const response = props.controlUnitService.getSshTunnelStatus(tunnelId);
        response.then((res) => {
            setUserConnectionState(res.data.sourceConnectionState);
            setControlUnitConnectionState(res.data.destinationConnectionState);
        });
    }


    const getSshTunnel = () => {
        setIsTunnelRequestInProgress(true);
        const response = props.controlUnitService.getSshTunnel(props.controlUnitId);
        response.then((res) => {
            setIsTunnelRequestInProgress(false);
            setTunnelId(res.data.tunnelId);
            getSshTunnelStatus(res.data.tunnelId);
            setTunnelDescription(res.data.description);
            setTunnelCreatedAt(res.data.createdAt);
            let commands = [];
            commands = res.data.shellCommands.map(obj => {
                return {command: obj}
            })
            if (commands.length === 0) {
                setIsCommandsEmpty(true);
            } else {
                setIsCommandsEmpty(false);
            }
            setCommandsData(commands);
        }).catch(() => {
            setIsTunnelRequestInProgress(false);
            setIsSshTunnelActive(false);
        })
    }

    const openSshTunnel = () => {
        const userEmail = stateObj.state.email;
        setIsFirstRequest(false);
        setIsTunnelRequestInProgress(true);
        const response = props.controlUnitService.openSshTunnel(props.controlUnitId, userEmail, pathValue);
        response.then(res => {
            setIsTunnelRequestInProgress(false);
            setIsSshTunnelActive(true);
            setTunnelId(res.data.tunnelId);
            getSshTunnelStatus(res.data.tunnelId);
            setTunnelDescription(res.data.description);
            setTunnelCreatedAt(res.data.createdAt);
            let commands = [];
            commands = res.data.shellCommands.map(obj => {
                return {command: obj}
            })
            if (commands.length === 0) {
                setIsCommandsEmpty(true);
            } else {
                setIsCommandsEmpty(false);
            }
            setCommandsData(commands);
        }).catch((error) => {
            setErrorMessage(error.response.data.message);
            setShowErrorModal(true);
            setIsTunnelRequestInProgress(false);
            setIsSshTunnelActive(false);
        })
    }

    const closeSshTunnel = () => {
        setIsFirstRequest(false);
        setIsTunnelRequestInProgress(true);
        const response = props.controlUnitService.closeSshTunnel(tunnelId);
        response.then((res) => {
            clearInterval(intervalId);
            setIsTunnelRequestInProgress(false);
            setIsSshTunnelActive(false);
            setUserConnectionState('');
            setControlUnitConnectionState('');
        }).catch(() => {
            setIsTunnelRequestInProgress(false);
            setIsSshTunnelActive(true);
        })
    }

    useEffect(() => {
        getSshTunnel();
    }, [])

    useEffect(() => {
        clearInterval(intervalId);
        if (isSshTunnelActive && tunnelId) {
            let intervalNum = setInterval(async () => {
                getSshTunnelStatus(tunnelId);
            }, POLLING_TIME_INTERVAL);
            setIntervalId(intervalNum);
        } else {
            clearInterval(intervalId);
        }
    }, [tunnelId])

    return (<>
        <ErrorModal
            errorMessage={errorMessage}
            setShow={setShowErrorModal}
            show={showErrorModal}
        />
        <Card bsPrefix='tabCard' className='ml-3 mr-3'>
            <Card.Body>
                <Row className={'mt-5'}>
                    <Col xs={12} md={6}>
                        <Card className={'ml-5'}>
                            <Card.Header style={{borderTopLeftRadius: '1.25rem', borderTopRightRadius: '1.25rem'}}>
                                <div className={'d-inline'}>SSH Tunnel</div>
                                <div className={'d-inline'}>
                                    <CustomIcon
                                        className={'ml-2 mb-1'}
                                        width={25}
                                        height={25}
                                        src={sshTunnelIcon}
                                        alt={"sshTunnelIcon"}
                                    />
                                </div>
                            </Card.Header>
                            <Card.Body className={!isSshTunnelActive ? 'mb-3' : ''}>
                                {isTunnelRequestInProgress && !isFirstRequest ?
                                    <Button className='mr-2' variant="primary" disabled>
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                            className='mr-1'
                                        />
                                        {isSshTunnelActive ? 'Closing...' : 'Opening...'}
                                    </Button> : <Button onClick={isSshTunnelActive ? closeSshTunnel : openSshTunnel}
                                                        className='mr-2'> {isSshTunnelActive ? 'Close SSH Tunnel' : 'Open SSH Tunnel'}</Button>}
                                {isSshTunnelActive ? <>
                                    <div style={{textAlign: 'left'}}>
                                        <div className={'d-inline-block'}>
                                            <h6 className='mt-3'>Created at: </h6>
                                        </div>
                                        <div className={'d-inline-block ml-1'}>
                                            {moment(tunnelCreatedAt).utcOffset(utcOffset).format('lll') === 'Invalid date' ? '' : moment.utc(tunnelCreatedAt).utcOffset(utcOffset).format('lll')}
                                        </div>
                                    </div>
                                    <div style={{textAlign: 'left'}}>
                                        <div className={'d-inline-block'}>
                                            <h6>Description:</h6>
                                        </div>
                                        <div className={'d-inline-block ml-1'}>
                                            {tunnelDescription}
                                        </div>
                                    </div>
                                    <div style={{textAlign: 'left'}}>
                                        <div className={'d-inline-block'}>
                                            <h6>User:</h6>
                                        </div>
                                        <div className={'d-inline-block ml-1'}>
                                            {userConnectionState ? renderConnectionBadge(userConnectionState) :
                                                <Spinner size='sm' animation='border' variant='primary'/>}
                                        </div>
                                    </div>
                                    <div style={{textAlign: 'left'}}>
                                        <div className={'d-inline-block'}>
                                            <h6>Control Unit:</h6>
                                        </div>
                                        <div className={'d-inline-block ml-1'}>
                                            {controlUnitConnectionState ? renderConnectionBadge(controlUnitConnectionState) :
                                                <Spinner size='sm' animation='border' variant='primary'/>}
                                        </div>
                                    </div>
                                    {isCommandsEmpty ? null : <div className='mt-3'>
                                        <SshCommandsTable copyTextToClipboard={props.copyTextToClipboard}
                                                          data={commandsData}/>
                                    </div>}

                                </> : null}
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={{span: 6}}>
                        <Card className={'mr-5'}>
                            <Card.Header style={{borderTopLeftRadius: '1.25rem', borderTopRightRadius: '1.25rem'}}>
                                <div className={'d-inline'}> SSH Key File</div>
                                <div className={'d-inline'}>
                                    <CustomIcon
                                        className={'ml-2 mb-1'}
                                        width={25}
                                        height={25}
                                        src={keyFileIcon}
                                        alt={"keyFileIcon"}

                                    />
                                </div>
                            </Card.Header>
                            <Card.Body>
                                <>
                                    <Form>
                                        <Form.Group as={Row} controlId="formGridId1">
                                            <Form.Label className={'ml-4'} column sm="1">Path:</Form.Label>
                                            <Col sm="6">
                                                <Form.Control value={pathValue}
                                                              onChange={(e) => setPathValue(e.target.value)}/>
                                            </Col>
                                            <Col sm="1">
                                                <Button onClick={() => props.copyTextToClipboard(pathValue)}
                                                        className='p-0 m-0' variant={'link'} style={{color: 'black'}}>
                                                    <TbCopy size={25}/>
                                                </Button>
                                            </Col>
                                            <Col sm="1">
                                                <Button style={{width: 100}} onClick={chooseFile}>Browse...</Button>
                                            </Col>
                                            <Col sm="1" className='ml-5 pl-0'>
                                                <Button style={{width: 100}} onClick={downloadSshKey}>Download</Button>
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    </>)
}
